import React from 'react';
import '../styles/Propos.css';

const Propos = () => {
  return (
    <main className="propos-wrapper">
      <section className="propos-hero">
        <h1>À propos de Asprotaxi</h1>
        <p>
          Votre chauffeur de confiance à Montbéliard & Sainte-Suzanne.
        </p>
      </section>

      <section className="propos-content">
        <h2>Qui sommes-nous ?</h2>
        <p>
          Asprotaxi est une entreprise de transport local implantée à Montbéliard et Sainte-Suzanne. 
          Fort d’une expérience dans le domaine du transport de personnes, je vous accompagne avec professionnalisme, ponctualité et discrétion.
        </p>

        <h2>Nos valeurs</h2>
        <ul>
          <li><strong>✔ Ponctualité :</strong> toujours à l’heure pour vos trajets importants.</li>
          <li><strong>✔ Confort :</strong> véhicule propre, climatisé, adapté à vos besoins.</li>
          <li><strong>✔ Accessibilité :</strong> service pour tous : familles, enfants, personnes âgées, PMR.</li>
          <li><strong>✔ Disponibilité :</strong> 7j/7 sur réservation.</li>
        </ul>

        <h2>Zones desservies</h2>
        <p>
          Je suis basé à <strong>Montbéliard</strong> et <strong>Sainte-Suzanne</strong>, avec possibilité de prise en charge ou de dépôt :
        </p>
        <ul>
          <li>Aéroports : Bâle‑Mulhouse, Dole, Strasbourg...</li>
          <li>Gares, hôpitaux, cliniques</li>
          <li>Trajets locaux ou longue distance</li>
        </ul>

        <h2>Contact</h2>
        <p>
          📞 <strong>Téléphone :</strong> <a href="tel:+33777685938">+33 7 77 68 59 38</a><br />
          ✉️ <strong>Email :</strong> <a href="mailto:taxi.asprotaxi@gmail.com">taxi.asprotaxi@gmail.com</a>
        </p>
      </section>
    </main>
  );
};

export default Propos;
